import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/datatable.graphql'
import { SettingPageCustomTimeRangeFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Block from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/SpecialWorkHours/Body/Block'
import HoverButton from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/SpecialWorkHours/Body/HoverButton'

interface ContentProps {
  timeRanges: SettingPageCustomTimeRangeFragment[]
  base: boolean
  dayType?: AttendanceCustomTimeRangeDayEnum
  hover: boolean
  showNotDefined: boolean
  isSpecificDateMode?: boolean
}

const Content = ({
  timeRanges,
  base,
  dayType,
  hover,
  showNotDefined,
  isSpecificDateMode,
}: ContentProps) => {
  const [isAddingNewBlock, setIsAddingNewBlock] = React.useState(false)

  if (!!timeRanges.length) return <Block timeRanges={timeRanges} base={base} />

  if ((hover && showNotDefined) || isAddingNewBlock)
    return (
      <HoverButton
        dayType={dayType}
        setIsAddingNewBlock={setIsAddingNewBlock}
        isAddingNewBlock={isAddingNewBlock}
        isSpecificDateMode={isSpecificDateMode}
      />
    )

  if (showNotDefined)
    return (
      <Box paddingY="s12">
        <Text.Normal size="200" color="grey600" ellipsis>
          {i18n.t('time_tracking.settings.custom_time_range_section.not_defined')}
        </Text.Normal>
      </Box>
    )

  return <Box padding="s24" alignItems="center" />
}

export default Content
